module.exports = __webpack_public_path__ + "img/kitabmaulana.2df2da77.jpg";